<template>
  <div id="add-hashtag">
    <alert-dynamic-component :key="res_key" v-if="res == 'berhasil'" type="success" title="Berhasil!"
      subtitle="Tagar berhasil ditambahkan." />
    <alert-dynamic-component :key="res_key" v-if="res == 'gagal'" type="danger" title="Gagal!" :subtitle="res_message" />
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group input-group input-group-left mb-0">
        <label for="addhashtag">Tagar <span class="text-danger">*</span></label>
        <div class="form-group input-group transparent">
          <div class="input-group-prepend">
            <span class="input-group-text transparent"><i class="bi bi-hash"></i></span>
          </div>
          <input type="text" v-model="hashtag" placeholder="Masukan Tagar" class="form-control" required
            @input="handleInput" />
        </div>
        <small class="text-muted d-block">
          <i class="bi bi-info-circle mr-1"></i> Masukkan Tagar tanpa tanda #
        </small>
        <small class="text-muted d-block">
          <i class="bi bi-info-circle mr-1"></i> Tagar hanya untuk Instagram
        </small>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-warning">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import alert_dynamic from "@/views/components/alert_dynamic.vue";

export default {
  name: "modal_add_hashtag",
  components: {
    "alert-dynamic-component": alert_dynamic,
  },
  data() {
    return {
      hashtag: null,
      res: null,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      res_key: 0,
      res_message: "",
    };
  },
  methods: {
    submitForm: function () {
      this.res = null;
      let params = {
        _id: this.id_project,
        hashtag: this.$sanitize(this.hashtag),
      };
      let api = process.env.VUE_APP_API_URL + "hashtag-add";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            this.$parent.$parent.getHashtag();
            this.hashtag = null;
            this.res = "berhasil";
          } else {
            this.res = "gagal";
          }
        })
        .catch((error) => {
          this.res_message = "Hashtag gagal ditambahkan. ";
          this.res_message += error.response.data.status;
          this.res = "gagal";
        })
        .finally(() => {
          this.res_key++;
        });
    },
    handleInput(event) {
      this.hashtag = event.target.value.replace(/\s/g, "");
    },

  },
};
</script>